import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  BulkDeleteArrearsRequestInput,
  PayrollBulkDeleteArrearsGraphQLRequest,
  PayrollBulkDeleteArrearsResponse,
} from '../types';

const payrollBulkDeleteArrearsMutation = gql`
  mutation PayrollBulkDeleteArrears($input: BulkDeleteArrearsRequestInput!) {
    payrollBulkDeleteArrears(input: $input) {
      code
      success
      message
      data {
        message
        totalDeleted
        totalFailed
        deletionResults {
          userId
          targetMonth
          sourceMonth
          errorMessage
          deletedArrearId
        }
      }
    }
  }
`;

export const bulkDeleteArrears = (input: BulkDeleteArrearsRequestInput) => {
  return graphQLApi<PayrollBulkDeleteArrearsResponse, PayrollBulkDeleteArrearsGraphQLRequest>({
    query: payrollBulkDeleteArrearsMutation,
    queryVariables: { input },
  });
};

